<template>
    <div>
        <div class="cmyr" v-if="item">
            <div class="cmyr-header">
                <div class="cmyr-header-tit">
                    宝宝{{item.sex==0?"爸爸":"妈妈"}},{{new Date().getHours()>12?'下午好':'上午好'}}
                </div>
                <div class="cmyr-header-content">
                    每个孩子都有自己独特的优势，想一想，小宝擅长什么呢？多欣赏他的长处吧，不要拿他的短处和别的孩子比较。
                </div>
                <div class="cmyr-ilist">
                <div class="cmyr-icon" @click="goto('/wikimore')">
                    <div class="cmyr-iconm">
                        <van-icon
                            class-prefix="abc-icon"
                            name="baike"
                            :size="30"
                            :color="$abctheme.basecolor"
                        />
                    </div>
                    <div >
                        百科
                    </div>
                </div>
                <div class="cmyr-icon" @click="goto('/foodmore')">
                    <div class="cmyr-iconm">
                        <van-icon
                            class-prefix="abc-icon"
                            name="chi"
                            :size="30"
                            :color="$abctheme.basecolor"
                        />
                    </div>
                    <div>
                        能不能吃
                    </div>
                </div>
            </div>
            </div>
            
            <div class="cmyrmc" v-if="vinfos&&vinfos.length>0">
                <div class="cmyr-headers">
                    <span class="cmyr-headers-tit">育儿要点</span>
                    <!-- <span class="cmyr-header-stit">更多</span> -->
                </div>
                <div class="cmyr-mlists">
                    <div class="cmyr-list" v-for="(item,index) in vinfos" :key="index" @click="godetail(item)">
                        <div class="cmyr-list-info">
                            <div class="cmyr-list-info-pic">
                                <img :src="$baseurl+item.img"/>
                            </div>
                            <div class="cmyr-list-info-content">
                                {{item.title}}
                            </div>
                            <div class="cmyr-list-info-scontent">
                                {{item.subTitle}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'cmy',
    props:{
        item:{
            type:Object,
            default:undefined
        }
    },
    data(){
        return{
            params: {
                sorting: " sorter desc,id desc",
                maxResultCount: 3,
                skipCount: 0,
                encyclopediaCateId:undefined
            },
            vinfos:[]
        }
    },
    created(){
        this.queryinfo();
    },
    methods:{
        queryinfo()
        {
            this.ajax
            .post("/api/services/app/PhoneWiki/QueryArticleList", this.params).then(x=>
            {
                    this.vinfos=x.result.items;
            })
        },
        goto(url)
        {
            this.$router.push({path:url});
        },
        godetail(item)
        {
            this.$router.push({path:'wikiarticledetail',query:{id:item.id}})
        }
    }
}
</script>
<style lang="scss" scoped>
.cmyr{
    text-align: left;
    font-size: 14px;
}
.cmyr-header{
    padding: 10px;
    background-color: #fff;
}
.cmyr-header-tit{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}
.cmyr-header-content{
    word-break: break-all;
    margin-bottom: 10px;
}

.cmyr-icons{
    display: flex;
    font-size: 12px;
}
.cmyr-icon{
    display: inline-block;
    width: 25%;
    text-align: center;
}
.cmyrmc{
    margin-top: 10px;
    padding: 10px;
    background-color: #fff;
}
.cmyr-headers{
    padding: 10px;
    padding-top:0px;
}
.cmyr-headers-tit{
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 10px;
}
.cmyr-header-stit{
    float: right;
}
.cmyr-list{
    margin-bottom: 5px;
}
.cmyr-list-info{
    padding-left:120px;
    min-height: 70px;
}
.cmyr-list-info-pic{
    position: absolute;
    left: 20px;
    width: 100px;
    height: 70px;
    border-radius: 4px;
}
.cmyr-list-info-pic img{
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.cmyr-list-info-content{
    font-weight: 500;
    line-height: 21px;
    min-height: 42px;
    margin-bottom: 10px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box; 
    white-space:pre-wrap;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
}
.cmyr-list-info-scontent{
    font-size: 12px;
    color:#a8a8a8;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box; 
    white-space:pre-wrap;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;
}
</style>